import 'datatables.net-dt/css/dataTables.dataTables.css';
import 'datatables.net';
import $ from 'jquery';
import DropdownActionsWrapper from '@/components/probaworkflows_base_components/DropdownActionsWrapper/DropdownActionsWrapper.vue'

export default {
  name: 'GlobalTable',
  components:{
    DropdownActionsWrapper
  },
  data: () => ({
    is_initializing: false,
  }),
  props: {
    headers: Array,
    data: Array,
    fields: Array,
    table_id: {
      type: String,
      default: 'global_table'
    },
    use_action_dropdown: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.initialize_data_table();
  },
  beforeUnmount() {
    this.destroy_data_table();
  },
  methods: {
    get_row_key(row, index) {
      if (row && row.id !== undefined && row.id !== null) {
        return `row-${row.id}`;
      }
      return `row-index-${index}`;
    },

    destroy_data_table() {
      const table_id = `#${this.table_id}`;
      if (!$.fn.DataTable.isDataTable(table_id)) {
        return;
      }

      try {
        $(table_id).DataTable().clear().destroy();
      } catch (error) {
        // DataTable cleanup - no action needed if already destroyed
      }
    },

    initialize_data_table() {
      this.is_initializing = true;
      this.$nextTick(() => {
        const table_id = `#${this.table_id}`;
        const table_element = $(table_id);

        if (!table_element.length) {
          this.is_initializing = false;
          return;
        }

        this.destroy_data_table();

        if (this.data && this.data.length > 0) {
          table_element.DataTable({
            autoWidth: false,
            responsive: true,
            ordering: false,
            language: {
              info: "",
              lengthMenu: "_MENU_&nbsp;&nbsp; entries per page",
              emptyTable: ""
            }
          });
        }
        this.is_initializing = false;
      });
    }
  },
  watch: {
    data() {
      this.initialize_data_table();
    }
  }
};
